import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment.development';
import { Product } from '../../../core/models/product';

@Injectable({
  providedIn: 'root',
})
export class HomeServiceService {
  constructor(private http: HttpClient) { }
  getProduct(filter: any) {
    return this.http.post<Product>(`${environment.api}product/all`, filter);
  }
  getProductNews(body) {
    return this.http.post<Product>(`${environment.api}product/news`, body);
  }
  getProductStock(filter: any) {
    return this.http.post<Product>(`${environment.api}product/stock`, filter);
  }
}
